<h1 mat-dialog-title [ngClass]="needsAiDisclaimer ? 'red-text' : ''">{{ data.title }}</h1>
<div mat-dialog-content>

    <div [innerText]="data.message"></div>

    <!--
        THIS LIST WAS PATIENT-SHAPED, and only patient-shaped.

        It renders `name`/`surname`/`title`, falling back to a `patient` property — which is right
        for the slot-conflict confirm it was built for. A caller passing plain STRINGS got a
        bullet per row with nothing in it: every branch read a property that a string does not
        have, and an empty `{{ }}` is not an error anywhere.

        A string row is now drawn as itself. The patient branches below are untouched.
    -->
    <div *ngIf="data.data">
        <ul>
            <li *ngFor="let items of data.data">
                <ng-container *ngIf="isTextRow(items); else personRow">{{ items }}</ng-container>

                <ng-template #personRow>
                    <!-- If the patient data is an object with properties -->
                    <div *ngIf="items.name || items.surname; else fullNameTemplate">
                        <span *ngIf="items.title">{{items.title}} </span>{{items.name}}
                        {{items.surname}}
                    </div>
                    <!-- Template to use if patient data is just a string (full name) -->
                    <ng-template #fullNameTemplate>
                        {{items.patient}}
                    </ng-template>
                </ng-template>
            </li>
        </ul>
    </div>

    <p class="hint" *ngIf="needsAiDisclaimer"><strong>Note: </strong>MedicAI can make mistakes. We advise that you check the
        content of the output carefully before accepting it into the patient file.</p>

</div>
<div mat-dialog-actions class="dialog-actions">
    <button mat-button [color]="data.cancelButtonTheme || ''" [disabled]="cooldownRemaining > 0" (click)="dialogRef.close(false)">{{ cancelButtonLabel }}</button>
    <button mat-button *ngIf="!hideConfirm" color="primary" [disabled]="cooldownRemaining > 0" (click)="dialogRef.close(true)">{{ confirmButtonLabel }}</button>
    <button mat-button *ngIf="data.showAdditionalButton" [disabled]="cooldownRemaining > 0" (click)="dialogRef.close('additional')">{{ additionalButtonLabel }}</button>
</div>